<div>
	<p-dialog appendTo="body" [(visible)]="visible" (onHide)="hide()" [modal]="true" [resizable]="false"
		[style]="{'width': '920px', 'height': '900px'}">

		<p-header>
			<span>Ping History</span>
		</p-header>

		<div>

			<ping-history [visible]="visible" [monitorType]="monitorType" [deviceGuid]="deviceGuid"
				[monitorPolicyGuid]="monitorPolicyGuid"></ping-history>

		</div>

		<p-footer>
			<button type="button" pButton icon="fa fa-close" (click)="hide()" label="Close"></button>
		</p-footer>

	</p-dialog>

</div>